import React, { FC, useEffect, useState } from 'react';
import {
  PageWrapper,
  useShowConfirmationPopup,
  useShowAlertPopup,
  Customer,
  Operation,
  Product,
  User,
  Lead,
  LoadingAnimation,
  GenericList,
  OperationStateIcon,
  FilterListInput,
  AdditionalOperationListContent,
} from '@dew21/ui';
import axios from 'axios';

export const Operations: FC = (props) => {
  const showConfirmationPopup = useShowConfirmationPopup();
  const showNotificationBanner = useShowAlertPopup();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [users, setUsers] = useState<User[] | null>(null);
  const [customers, setCustomers] = useState<Customer[] | null>(null);
  const [products, setProducts] = useState<Product[] | null>(null);
  const [leads, setLeads] = useState<Lead[] | null>(null);
  const [operations, setOperations] = useState<Operation[] | null>(null);
  const [filteredOperations, setFilteredOperations] = useState<Operation[] | null>(null);

  const fetchUsers = async () => {
    return axios.get('/api/users');
  };

  const fetchProducts = async () => {
    return axios.get('/api/product/all');
  };

  const fetchLeads = async () => {
    return axios.get('/api/leads');
  };

  const fetchCustomers = async () => {
    return axios.get('/api/customers');
  };

  const fetchOperations = async () => {
    return axios.get('/api/operations');
  };

  useEffect(() => {
    setIsLoading(true);
    fetchUsers()
      .then((response) => setUsers(response.data))
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (users) {
      fetchCustomers()
        .then((response) => setCustomers(response.data))
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    }
  }, [users]);

  useEffect(() => {
    if (customers) {
      fetchProducts()
        .then((response) => setProducts(response.data))
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    }
  }, [customers]);

  useEffect(() => {
    if (products) {
      fetchLeads()
        .then((response) => {
          setLeads(response.data);
        })
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    }
  }, [products]);

  useEffect(() => {
    if (leads) {
      fetchOperations()
        .then((response) => {
          setOperations(response.data);
          setFilteredOperations(response.data);
          setIsLoading(false);
        })
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    }
  }, [leads]);

  return (
    <PageWrapper
      breadCrumb={[{ title: 'Vorgänge', path: '/operations' }]}
      marginal={{
        items: [],
      }}>

      {
        (leads && leads.length > 0) && <FilterListInput
          id={'filter-operations'}
          label={'Vorgangssuche'}
          onChange={(value: string | null) => {
            if (value && operations) {
              const condition = operations.filter((operation) => {
                const user = users?.find((user) => user.id === operation.userId);
                const matchingStringUser = user ? `${user.firstName} ${user.familyName}`.toLowerCase() : `${operation.userId}`.toLowerCase();

                const customer = customers?.find((customer) => customer.id === operation.customerId);
                const matchingStringCustomer = customer ? `${customer.name}`.toLowerCase() : `${operation.customerId}`.toLowerCase();
                const lowerValue = value.toLowerCase();

                if (matchingStringUser.includes(lowerValue) || matchingStringCustomer.includes(lowerValue)) {
                  return operation;
                }

              }).filter((operation) => operation !== null) || leads;
              setFilteredOperations(condition);
            } else {
              setFilteredOperations(operations);
            }
          }}
          placeholder={'Unternehmensname oder Vorname Nachname'}/>
      }

      {
        (filteredOperations !== null && filteredOperations.length > 0 && !isLoading) ?
          <GenericList
            collapsible={true}
            displayColumnNames={true}
            countLabel={filteredOperations.length > 1 ? `${filteredOperations.length} Vorgänge` : `${filteredOperations.length} Vorgang`}
            columns={[
              {
                name: 'userId',
                displayName: 'Berater',
                sortable: true,
                formatFn: (value) => {
                  const user = users?.find((user) => user.id === value);
                  return user ? `${user.firstName} ${user.familyName}` : 'Nicht gefunden';
                },
              },
              {
                name: 'customerId',
                displayName: 'Kunde',
                sortable: true,
                formatFn: (value) => {
                  const customer = customers?.find((customer) => customer.id === value);
                  return customer ? `${customer.name}` : 'Nicht gefunden';
                },
              },
              {
                name: 'updatedAt',
                displayName: 'Letzte Änderung',
                sortable: true,
                formatFn: (value) => {
                  return new Date(value).toLocaleDateString('DE');
                },
              },
              {
                name: 'status',
                displayName: 'Status',
                sortable: true,
                formatFn: (value) => {
                  return <OperationStateIcon value={value}/>;
                },
              },
            ]}
            items={filteredOperations}
            additionalRenderFn={(operation) => (
              <AdditionalOperationListContent
                operation={operation}
                users={users || []}
                products={products || []}
                customers={customers || []}/>
            )}/> :
          <>Keine Vorgänge gefunden.</>
      }

      {
        isLoading && <LoadingAnimation transparent overlay/>
      }
    </PageWrapper>
  );
};
